import { getProductArchiveFilterSingleComponent } from './productArchiveFilterSingle.vue.js';

export function getProductArchiveFilterComponent(idBase) {
    return {
        name: 'ProductArchiveFilter',
        components: {
            ProductArchiveFilterSingle: getProductArchiveFilterSingleComponent(idBase),
        },
        props: {
            orderBy: {
                type: String,
                required: true,
            },
            orderOptions: {
                type: Object,
                required: true,
            },
            hideBundles: {
                type: Boolean,
                required: true,
            },
            showOnlyInStock: {
                type: Boolean,
                required: true,
            },
            showOnlyForwardingGoods: {
                type: Boolean,
                required: true,
            },
            filterAttributes: {
                type: Array,
                required: true,
            },
            filterBy: {
                type: Object,
                required: true,
            },
            products: {
                type: Array,
                required: true,
                default: [],
            },
        },
        data() {
            const models = {};

            for (const attribute of this.filterAttributes) {
                models[attribute.name] = this.filterBy[attribute.name] || [];
            }

            return {
                orderByModel: this.orderBy,
                showOnlyInStockModel: false,
                showOnlyForwardingGoodsModel: false,
                hideBundlesModel: false,
                isCollapsed: false,
                models,
                expandedFilter: '',
            };
        },
        watch: {
            hideBundles(hideBundles) {
                this.hideBundlesModel = hideBundles;
            },
            showOnlyInStock(showOnlyInStock) {
                this.showOnlyInStockModel = showOnlyInStock;
            },
            showOnlyForwardingGoods(showOnlyForwardingGoods) {
                this.showOnlyForwardingGoodsModel = showOnlyForwardingGoods;
            },
            filterBy(filterBy) {
                for (const setting in filterBy) {
                    if (Object.prototype.hasOwnProperty.call(filterBy, setting)) {
                        this.models[setting] = filterBy[setting];
                    }
                }
            },
        },
        computed: {
            options() {
                const options = [];

                for (const option in this.orderOptions) {
                    if (Object.prototype.hasOwnProperty.call(this.orderOptions, option)) {
                        options.push({
                            value: option,
                            text: this.orderOptions[option],
                        });
                    }
                }
                return options;
            },
        },
        mounted() {
            document.addEventListener('click', () => {
                this.expandedFilter = '';
            });

            document.addEventListener('keydown', (event) => {
                if (event.key === 'Escape') {
                    this.expandedFilter = '';
                }
            });
        },
        methods: {
            onExclusiveChange(checkbox) {
                if (checkbox === 'inStock' && this.showOnlyInStockModel === true) {
                    this.showOnlyForwardingGoodsModel = false;
                } else if (checkbox === 'forwardingGoods' && this.showOnlyForwardingGoodsModel === true) {
                    this.showOnlyInStockModel = false;
                }

                this.onChange();
            },
            onChange() {
                this.$emit('settings-changed', {
                    orderBy: this.orderByModel,
                    hideBundles: this.hideBundlesModel,
                    showOnlyInStock: this.showOnlyInStockModel,
                    showOnlyForwardingGoods: this.showOnlyForwardingGoodsModel,
                    filterBy: this.models,
                });
            },
            onCollapseToggle() {
                this.isCollapsed = !this.isCollapsed;
            },
            onSingleFilterToggle({ attribute }) {
                if (this.expandedFilter === attribute.id) {
                    this.expandedFilter = '';
                } else {
                    this.expandedFilter = attribute.id;
                }
            },
        },
        template: `#${idBase}-filter`,
    };
}
